import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-roaming-search-country-modal',
  templateUrl: './roaming-search-country-modal.component.html',
  styleUrls: ['./roaming-search-country-modal.component.scss']
})
export class RoamingSearchCountryModalComponent implements OnInit {

  constructor(
    private modalController: ModalController,
    private SS: SubjectService,
  ) {
    
   }

  ngOnInit(): void {
  }
  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
    this.SS.filterPopupOpenCountryList.next(false);
  }
}
